
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'PortfolioPublicityToggle',
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
      validator: (value: string) => ['sm', 'md'].includes(value),
    },
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
  computed: {
    rootClass() {
      return ['portfolio-publicity-toggle', `portfolio-publicity-toggle--${this.size}`];
    },
  },
});
